import Moment from "moment";
import * as R from "ramda";
import React, { Component } from "react";
import Api from "../../../../Services/Api";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../../modules/popup/SimplePrintTable";
import {
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../../common/mapper";
import ReceivingPartDGIDetail from "./receivingPartDGIDetail";
import ReceivingPartDGIFilter from "./receivingPartDGIFilter";
import ReceivingPartDGISearch from "./receivingPartDGISearch";
import moment from "moment";
import { contructQueryParam, getUserAccess } from "../../../../Services/Utils";

class ReceivingPartDGI extends Component {
  tableColumns = [
    {
      name: "id",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const page = this.state.pagination.page - 1;
          const limit = this.state.pagination.limit;

          const rowNumber = page * limit + tableMeta.rowIndex + 1;
          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    {
      name: "shippingDate",
      label: "Tanggal SL",
      options: {
        sort: false,
      },
    },
    {
      name: "shippingNo",
      label: "No. Shipping List (SL)",
      options: {
        sort: false,
      },
    },
    {
      name: "receivedNo",
      label: "No. Penerimaan",
      options: {
        sort: false,
      },
    },
    {
      name: "quantity",
      label: "Jumlah",
      options: {
        sort: false,
      },
    },
    {
      name: "receivingPartDGIId",
      label: "Aksi",
      options: {
        customBodyRender: (val) => {
          const isDisabled = this.state.userAccess?.createAccess === false;
          return (
            <SimpleButton
              secondary
              style={{
                background: isDisabled ? "grey" : "#e74c3c",
                color: "white",
                marginLeft: 0,
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
              type="button"
              text="Proses"
              disabled={isDisabled}
              onClick={() => {
                if (isDisabled) return;
                this.handleModalDetailVisibility(val);
              }}
            />
          );
        },
        sort: false,
      },
    },
  ];

  constructor(props) {
    super(props);
    this.slDateInitialValue = {
      endDate: moment(new Date()).format("DD-MM-YYYY"),
      startDate: moment(new Date()).format("DD-MM-YYYY"),
    };
    this.initialFilterData = {
      startDate: "",
      endDate: "",
      shippingNo: "",
      receivedNo: "",
      partCode: "",
      partName: "",
      category: "",
      purchaseOrderNo: "",
    };
    this.state = {
      printVisible: false,
      loading: false,
      filterVisible: false,
      detailVisible: false,
      selectedData: null,
      submittedFilterData: {},
      filterData: {},
      searchData: {
        ...this.slDateInitialValue,
      },
      filterData: this.initialFilterData,
      kodeCabang: null,
      pagination: {
        totalData: 1,
        page: 1,
        limit: 5,
      },
      cabangOptions: [],
      dataTable: [],
    };
  }

  // async componentDidMount() {
  //   this.handleTriggerLoading();
  //   let options = [];
  //   const responses = await Promise.all(
  //     this.props.menuAccess.map((ma) =>
  //       Api.create("NAGAMAS_MASTER_DATA").getMasterCabangById(ma.idRefObj)
  //     )
  //   );
  //   responses.forEach((r) => {
  //     if (r.ok) {
  //       options.push(
  //         mapToObjectDDL(r.data.data.namaDealer, r.data.data.kodeCabang)
  //       );
  //     }
  //   });
  //   this.setState((prevValue) => ({
  //     ...prevValue,
  //     kodeCabang: { ...options[0] },
  //     cabangOptions: [...options],
  //   }));
  //   await this.fetchData({
  //     kodeCabang: options[0]?.value,
  //     startDate: moment(new Date()).format("DD-MM-YYYY"),
  //     endDate: moment(new Date()).format("DD-MM-YYYY"),
  //   });
  //   this.handleTriggerLoading();
  // }

  async componentDidMount() {
    this.handleTriggerLoading();

    try {
      const res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();

      if (res.ok) {
        const filteredCabang = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((access) => access.idRefObj)
            .includes(item.kodeCabang),
        );

        const options = filteredCabang.map((item) =>
          mapToObjectDDL(item.namaDealer, item.kodeCabang),
        );

        if (options.length > 0) {
          const selectedCabang = { ...options[0] };

          this.setState(
            {
              kodeCabang: selectedCabang,
              cabangOptions: options,
              userAccess: getUserAccess(
                this.props.menuAccess,
                selectedCabang.value,
              ),
            },
            async () => {
              await this.fetchData({
                kodeCabang: selectedCabang.value,
                startDate: moment(new Date()).format("DD-MM-YYYY"),
                endDate: moment(new Date()).format("DD-MM-YYYY"),
              });
            },
          );
        }
      }
    } catch (err) {
      console.error("Error fetching master cabang:", err);
    }

    this.handleTriggerLoading();
  }

  async componentDidUpdate(prevProps, prevState) {
    const { page, limit } = this.state.pagination;

    if (
      prevState.pagination.page !== page ||
      prevState.pagination.limit !== limit
    ) {
      await this.fetchData(this.state.submittedFilterData);
    }
  }

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  reloadCurrentPage = async (extraFilter = {}) => {
    const { page, limit } = this.state.pagination;

    const filterToUse =
      Object.keys(extraFilter).length > 0
        ? extraFilter
        : this.state.submittedFilterData;

    await this.fetchData(filterToUse, page, limit);
  };

  fetchData = async (filter = {}) => {
    const { page, limit } = this.state.pagination;

    this.handleTriggerLoading();

    const response = await Api.create("NAGAMAS_DGI").getAllReceivingPartDGI({
      ...filter,
      kodeCabang: this.state.kodeCabang.value,
      page,
      limit,
    });

    if (response.ok) {
      this.setState((prev) => ({
        dataTable: response.data?.data || [],
        pagination: {
          ...prev.pagination,
          totalData: response.data?.totalData,
        },
      }));
    }

    this.handleTriggerLoading();
  };

  handleModalFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleModalDetailVisibility = async (id, action = "", type) => {
    console.log(id);

    if (id) {
      let response = await Api.create("NAGAMAS_DGI").getAllReceivingPartDGIBy(
        contructQueryParam({
          receivingPartDGIId: id,
        }),
      );

      if (response.ok && !R.isNil(response.data.data)) {
        this.setState((prevState) => ({
          ...prevState,
          selectedData: response.data.data,
          actionType: type,
          detailVisible: !prevState.detailVisible,
        }));
      }
    } else {
      if (action === "refresh") {
        this.setState((prevValue) => ({
          ...prevValue,
          searchData: {
            endDateSL: null,
            startDateSL: null,
          },
          submittedFilterData: {},
          selectedData: null,
          detailVisible: !prevValue.detailVisible,
        }));
        await this.reloadCurrentPage();
      } else {
        this.setState((prevState) => ({
          ...prevState,
          selectedData: null,
          detailVisible: !prevState.detailVisible,
        }));
      }
    }
  };

  handleSubmitFilter = () => {
    const request = removeNullFields({
      ...this.state.filterData,
      startDate: this.state.filterData?.startDate
        ? Moment(this.state.filterData?.startDate).format("DD-MM-YYYY")
        : null,
      endDate: this.state.filterData?.endDate
        ? Moment(this.state.filterData?.endDate).format("DD-MM-YYYY")
        : null,
      kodeCabang: this.state.kodeCabang.value,
    });

    this.setState(
      (prev) => ({
        loading: true,
        searchData: {
          ...this.slDateInitialValue,
        },
        submittedFilterData: request,
        filterVisible: false,
        pagination: {
          ...prev.pagination,
          page: 1, 
        },
      }),
      async () => {
        try {
          await this.fetchData(request, 1, this.state.pagination.limit);
        } catch (error) {
          console.error("Error fetchData:", error);
        } finally {
          this.setState({ loading: false });
        }
      }
    );
  };

  handleStateChange = (callback) => {
    this.setState(callback);
  };

  handleClickSearch = async (e) => {
    e.preventDefault();

    this.setState((prevValue) => ({
      ...prevValue,
      loading: true,
      filterData: {},
    }));

    const today = moment().format("DD-MM-YYYY");

    let startDateRaw = this.state.searchData?.startDate;
    let endDateRaw = this.state.searchData?.endDate;

    const startDate = startDateRaw
      ? moment(startDateRaw, "DD-MM-YYYY").format("DD-MM-YYYY")
      : today;

    const endDate = endDateRaw
      ? moment(endDateRaw, "DD-MM-YYYY").format("DD-MM-YYYY")
      : today;

    const request = removeNullFields({ startDate, endDate });
    console.log(request);

    await this.fetchData(request);

    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: request,
      loading: false,
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prev) => ({
      pagination: {
        ...prev.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prev) => ({
      pagination: {
        ...prev.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: value,
      },
    }));
  };

  handleCabangChange = async (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
      searchData: {
        ...this.slDateInitialValue,
      },
      filterData: {},
      loading: true,
    }));
    await this.fetchData({
      kodeCabang: value.value,
      startDate: moment(new Date()).format("DD-MM-YYYY"),
      endDate: moment(new Date()).format("DD-MM-YYYY"),
    });
    this.setState((prevValue) => ({
      ...prevValue,
      loading: false,
    }));
  };

  handlePrint = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      printVisible: !prevValue.printVisible,
    }));
  };

  render() {
    return (
      <>
        <ReceivingPartDGISearch
          state={this.state}
          onSubmit={this.handleClickSearch}
          onShowFilter={this.handleModalFilterVisibility}
          onValueChange={this.handleValueChange}
          onCabangChange={this.handleCabangChange}
          menuAccess={this.props.menuAccess}
        />
        <SimpleDataTable
          key={`${this.state.pagination.page}-${this.state.pagination.limit}`}
          data={this.state.dataTable}
          columns={this.tableColumns}
          toCount={this.state.pagination.totalData}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage,
          )}
        />
        {this.state.filterVisible && (
          <ReceivingPartDGIFilter
            state={this.state}
            onSetState={this.handleStateChange}
            onClickClose={this.handleModalFilterVisibility}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {this.state.detailVisible && (
          <ReceivingPartDGIDetail
            state={this.state}
            onShowModal={(action) =>
              this.handleModalDetailVisibility(null, action)
            }
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.state.printVisible && (
          <SimplePrintTable onClearPrint={this.handlePrint} />
        )}
      </>
    );
  }
}

export default ReceivingPartDGI;
